// Generated from ./Restrictions.g4 by ANTLR 4.13.2
// noinspection ES6UnusedImports,JSUnusedGlobalSymbols,JSUnusedLocalSymbols
import {
	ATN,
	ATNDeserializer,
	CharStream,
	DecisionState, DFA,
	Lexer,
	LexerATNSimulator,
	RuleContext,
	PredictionContextCache,
	Token
} from "antlr4";
export default class RestrictionsLexer extends Lexer {
	public static readonly OR = 1;
	public static readonly AND = 2;
	public static readonly EQ = 3;
	public static readonly NEQ = 4;
	public static readonly MATCH = 5;
	public static readonly LPAREN = 6;
	public static readonly RPAREN = 7;
	public static readonly DOLLAR = 8;
	public static readonly POUND = 9;
	public static readonly STR = 10;
	public static readonly WORD = 11;
	public static readonly NUMBER = 12;
	public static readonly WS = 13;
	public static readonly EOF = Token.EOF;

	public static readonly channelNames: string[] = [ "DEFAULT_TOKEN_CHANNEL", "HIDDEN" ];
	public static readonly literalNames: (string | null)[] = [ null, "'||'", 
                                                            "'&&'", "'=='", 
                                                            "'!='", "'?'", 
                                                            "'('", "')'", 
                                                            "'$'", "'#'" ];
	public static readonly symbolicNames: (string | null)[] = [ null, "OR", 
                                                             "AND", "EQ", 
                                                             "NEQ", "MATCH", 
                                                             "LPAREN", "RPAREN", 
                                                             "DOLLAR", "POUND", 
                                                             "STR", "WORD", 
                                                             "NUMBER", "WS" ];
	public static readonly modeNames: string[] = [ "DEFAULT_MODE", ];

	public static readonly ruleNames: string[] = [
		"OR", "AND", "EQ", "NEQ", "MATCH", "LPAREN", "RPAREN", "DOLLAR", "POUND", 
		"STR", "WORD", "NUMBER", "WS",
	];


	constructor(input: CharStream) {
		super(input);
		this._interp = new LexerATNSimulator(this, RestrictionsLexer._ATN, RestrictionsLexer.DecisionsToDFA, new PredictionContextCache());
	}

	public get grammarFileName(): string { return "Restrictions.g4"; }

	public get literalNames(): (string | null)[] { return RestrictionsLexer.literalNames; }
	public get symbolicNames(): (string | null)[] { return RestrictionsLexer.symbolicNames; }
	public get ruleNames(): string[] { return RestrictionsLexer.ruleNames; }

	public get serializedATN(): number[] { return RestrictionsLexer._serializedATN; }

	public get channelNames(): string[] { return RestrictionsLexer.channelNames; }

	public get modeNames(): string[] { return RestrictionsLexer.modeNames; }

	public static readonly _serializedATN: number[] = [4,0,13,86,6,-1,2,0,7,
	0,2,1,7,1,2,2,7,2,2,3,7,3,2,4,7,4,2,5,7,5,2,6,7,6,2,7,7,7,2,8,7,8,2,9,7,
	9,2,10,7,10,2,11,7,11,2,12,7,12,1,0,1,0,1,0,1,1,1,1,1,1,1,2,1,2,1,2,1,3,
	1,3,1,3,1,4,1,4,1,5,1,5,1,6,1,6,1,7,1,7,1,8,1,8,1,9,1,9,4,9,52,8,9,11,9,
	12,9,53,1,9,1,9,1,10,4,10,59,8,10,11,10,12,10,60,1,11,3,11,64,8,11,1,11,
	5,11,67,8,11,10,11,12,11,70,9,11,1,11,3,11,73,8,11,1,11,4,11,76,8,11,11,
	11,12,11,77,1,12,4,12,81,8,12,11,12,12,12,82,1,12,1,12,0,0,13,1,1,3,2,5,
	3,7,4,9,5,11,6,13,7,15,8,17,9,19,10,21,11,23,12,25,13,1,0,5,1,0,39,39,4,
	0,45,45,65,90,95,95,97,122,2,0,43,43,45,45,1,0,48,57,2,0,9,9,32,32,92,0,
	1,1,0,0,0,0,3,1,0,0,0,0,5,1,0,0,0,0,7,1,0,0,0,0,9,1,0,0,0,0,11,1,0,0,0,
	0,13,1,0,0,0,0,15,1,0,0,0,0,17,1,0,0,0,0,19,1,0,0,0,0,21,1,0,0,0,0,23,1,
	0,0,0,0,25,1,0,0,0,1,27,1,0,0,0,3,30,1,0,0,0,5,33,1,0,0,0,7,36,1,0,0,0,
	9,39,1,0,0,0,11,41,1,0,0,0,13,43,1,0,0,0,15,45,1,0,0,0,17,47,1,0,0,0,19,
	49,1,0,0,0,21,58,1,0,0,0,23,63,1,0,0,0,25,80,1,0,0,0,27,28,5,124,0,0,28,
	29,5,124,0,0,29,2,1,0,0,0,30,31,5,38,0,0,31,32,5,38,0,0,32,4,1,0,0,0,33,
	34,5,61,0,0,34,35,5,61,0,0,35,6,1,0,0,0,36,37,5,33,0,0,37,38,5,61,0,0,38,
	8,1,0,0,0,39,40,5,63,0,0,40,10,1,0,0,0,41,42,5,40,0,0,42,12,1,0,0,0,43,
	44,5,41,0,0,44,14,1,0,0,0,45,46,5,36,0,0,46,16,1,0,0,0,47,48,5,35,0,0,48,
	18,1,0,0,0,49,51,7,0,0,0,50,52,8,0,0,0,51,50,1,0,0,0,52,53,1,0,0,0,53,51,
	1,0,0,0,53,54,1,0,0,0,54,55,1,0,0,0,55,56,7,0,0,0,56,20,1,0,0,0,57,59,7,
	1,0,0,58,57,1,0,0,0,59,60,1,0,0,0,60,58,1,0,0,0,60,61,1,0,0,0,61,22,1,0,
	0,0,62,64,7,2,0,0,63,62,1,0,0,0,63,64,1,0,0,0,64,68,1,0,0,0,65,67,7,3,0,
	0,66,65,1,0,0,0,67,70,1,0,0,0,68,66,1,0,0,0,68,69,1,0,0,0,69,72,1,0,0,0,
	70,68,1,0,0,0,71,73,9,0,0,0,72,71,1,0,0,0,72,73,1,0,0,0,73,75,1,0,0,0,74,
	76,7,3,0,0,75,74,1,0,0,0,76,77,1,0,0,0,77,75,1,0,0,0,77,78,1,0,0,0,78,24,
	1,0,0,0,79,81,7,4,0,0,80,79,1,0,0,0,81,82,1,0,0,0,82,80,1,0,0,0,82,83,1,
	0,0,0,83,84,1,0,0,0,84,85,6,12,0,0,85,26,1,0,0,0,8,0,53,60,63,68,72,77,
	82,1,6,0,0];

	private static __ATN: ATN;
	public static get _ATN(): ATN {
		if (!RestrictionsLexer.__ATN) {
			RestrictionsLexer.__ATN = new ATNDeserializer().deserialize(RestrictionsLexer._serializedATN);
		}

		return RestrictionsLexer.__ATN;
	}


	static DecisionsToDFA = RestrictionsLexer._ATN.decisionToState.map( (ds: DecisionState, index: number) => new DFA(ds, index) );
}